// Instagram-style mobile tab bar: while the user scrolls DOWN the pill
// shrinks to an icons-only capsule; any scroll UP (or being near the top)
// grows it back to icons + labels. Pure class toggle - the sizing lives in
// tabbar.css - throttled to one check per frame.
import { qs } from '../lib/dom.js';

export function initTabbar() {
  const bar = qs('.ap-tabbar');
  if (!bar) return;

  let lastY = window.scrollY;
  let ticking = false;

  const update = () => {
    ticking = false;
    const y = window.scrollY;
    const dy = y - lastY;
    if (Math.abs(dy) < 6) return; // ignore sub-frame jitter / rubber-banding
    if (y < 80 || dy < 0) {
      bar.classList.remove('is-compact');
    } else {
      bar.classList.add('is-compact');
    }
    lastY = y;
  };

  window.addEventListener('scroll', () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }, { passive: true });
}
